import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import S_LandingPage from './s_landingpage/s_landingpage';
import VideoPlayer from './s_app/components/videoPlayer';

import './css/app.css';
import './css/vivify.min.css'
import Welcome from './dad/welcome';
import Travel from './dad/distancetraveled';
import Spaghetti from './dad/spaghetti';
import Trip from './dad/trip';
import Nfl from './dad/nfl';
import Lowes from './dad/lowes';

import WelcomeS from './steven/welcomes';
import Drive from './steven/drive';
import Bus from './steven/bus';
import Playstation from './steven/playstation';

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Note: Changed the route to include :movieName before :playerId */}
        <Route path="/" element={<S_LandingPage />} >
          <Route path="/video/:movieName/:playerId" element={<VideoPlayer />} />
        </Route>
        <Route path="/dad" element={<Welcome />} />
        <Route path="/dad/spaghetti" element={<Spaghetti />} />
        <Route path="/dad/travel" element={<Travel />} />
        <Route path="/dad/trip" element={<Trip />} />
        <Route path="/dad/nfl" element={<Nfl />} />
        <Route path="/dad/lowes" element={<Lowes />} />

        <Route path="/steven" element={<WelcomeS />} />
        <Route path="/steven/drive" element={<Drive />} />
        <Route path="/steven/bus" element={<Bus />} />
        <Route path="/steven/playstation" element={<Playstation />} />

      </Routes>
    </Router>
  );
};

export default App;
